<template>
  <v-col v-if="!hide" cols="12">
    <v-card :class="loading && 'v-skeleton-loader v-skeleton-loader--is-loading badge-loading'">
      <v-card-title :class="loading && 'v-skeleton-loader__bone'">
        <section-header>
          {{ subcategory.engineName === 'KULTTUURI' ? $t('reports.culture_leadership') : subcategory.nameText }}
          <drop-down-menu :list-items="dropDownMenuItems"/>
        </section-header>
        <v-spacer/>
        <div :style="{ width: $vuetify.breakpoint.smAndDown ? '60px' : '80px' }" style="margin-bottom: -10px">
          <report-personnel-vs-management-chart
            v-if="!['ASIA', 'YKSILÖ', 'TIIMI'].includes(subcategory.engineName)"
            :category="category"
            :loading="loading"
            :name="subcategory.engineName"
            :scale="scale"
            :surveys="surveys"
            without-lines
          />
        </div>
      </v-card-title>
      <v-card-text :class="loading && 'v-skeleton-loader__bone'" class="text-body-2 text-sm-body-1 pb-6">
        {{ $t('reports.categories_explained.' + subcategory.engineName) }}
      </v-card-text>
      <s-w-o-t-legends :icon-size="$vuetify.breakpoint.mdAndUp?'24':'18'"
                       :larger="$vuetify.breakpoint.mdAndUp"
                       class="ml-4 mt-n2 mb-2"></s-w-o-t-legends>

      <template v-if="['ASIA', 'YKSILÖ', 'TIIMI'].includes(subcategory.engineName)">
        <v-card-text :class="loading && 'v-skeleton-loader__bone'" class="pt-0">
          <report-personnel-vs-management-chart
            :category="category"
            :loading="loading"
            :name="subcategory && subcategory.engineName"
            :scale="scale"
            :surveys="surveys"
          />
        </v-card-text>
      </template>
      <template v-else>
        <template v-for="subsubcategory in subcategory.children">
          <v-divider :key="`${subsubcategory.id}_divider`"></v-divider>
          <report-personnel-vs-management
            :key="subsubcategory.id"
            :category="category"
            :loading="loading"
            :name="subsubcategory.engineName"
            :scale="scale"
            :sub-sub-category="subsubcategory"
            :subcategory="subcategory"
            :surveys="surveys"
          />
        </template>
      </template>
    </v-card>
    <tasks-modal v-model="showTasks" :category="subcategory"/>
  </v-col>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';
import params from '@/parameters';
import ReportPersonnelVsManagement from '@/components/Tenant/ReportCategory/ReportPersonnelVsManagement';
import ReportPersonnelVsManagementChart from '@/components/Tenant/ReportCategory/ReportPersonnelVsManagementChart';
import DropDownMenu from '@/components/DropDownMenu';
import TasksModal from '@/components/Tenant/Tasks/TasksModal';
import SWOTLegends from "@/components/Tenant/Reports/SWOTLegends";

export default {
  name: 'ReportSubcategoryCard',
  components: {
    TasksModal,
    DropDownMenu,
    ReportPersonnelVsManagementChart,
    ReportPersonnelVsManagement,
    SectionHeader,
    SWOTLegends
  },
  props: ['surveys', 'category', 'categories', 'subcategory', 'scale', 'loading'],
  data() {
    return {
      showTasks: false,
    };
  },
  computed: {
    hide() {
      return this.subcategory?.engineName === 'KULTTUURI' && !this.managementSurvey
    },
    dropDownMenuItems() {
      return [
        {
          title: this.$t('reports.category_tasks', {
            name: this.subcategory.engineName === 'KULTTUURI' ? this.$t('reports.culture_leadership') : this.subcategory.nameText,
          }),
          icon: 'mdi mdi-format-list-checks',
          /*route: {
            name: 'tenant_tasks',
            params: {category: this.subcategory.id, parentCategory: this.category}
          }*/
          action: () => {
            this.showTasks = true;
          },
        },
        {
          title: this.$t('reports.category_history', {
            name: this.subcategory.engineName === 'KULTTUURI' ? this.$t('reports.culture_leadership') : this.subcategory.nameText,
          }),
          icon: 'mdi mdi-history' /*, todo action: something */,
        },
      ];
    },
    mappedSwots() {
      return params.mappedSwots;
    },
    personnelSurvey() {
      return this.surveys?.find(s => s.type === 'PERSONNEL');
    },
    managementSurvey() {
      return this.surveys?.find(s => s.type === 'MANAGEMENT');
    },
    strengthSwots() {
      return this.swots.filter(a => a.type === 'strength');
    },
    opportunitySwots() {
      return this.swots.filter(a => a.type === 'opportunity');
    },
    weaknessSwots() {
      return this.swots.filter(a => a.type === 'weakness');
    },
  },
};
</script>

<style scoped></style>
